'use strict';

var BusyIndicatorController = function BusyIndicatorController($rootScope, $scope) {
  function activateBusyIndicator(ev, keepItBy) {
    $scope.showIndicator(keepItBy);
  }
  function deactivateBusyIndicator(ev, releasedBy) {
    $scope.hideIndicator(releasedBy);
  }
  $rootScope.$on('loading:progress', activateBusyIndicator);
  $rootScope.$on('loading:finish', deactivateBusyIndicator);
};
BusyIndicatorController.$inject = ['$rootScope', '$scope'];
module.exports = BusyIndicatorController;